<template>
    <div class="edit-answer">
        <div class="answer-content scroll-tracker">
            <TitleBar class="answer-title">
                <span class="" v-show="!isTilteEditing">{{ answerName }}</span>
                <span v-if="isTilteEditing"
                    ><input :placeholder="answerName" v-model="titleValue" @keypress="keyPressHandler" @blur="emitEditEvent" ref="titleInput"
                /></span>
                <a class="title-edit-btn" @click="editTitle" v-show="!isTilteEditing"></a>
                <div class="answer-action">
                    <el-dropdown split-button class="copy-btn" @command="handleCommand" @click="copyClick('all')">
                        {{ copyLabel }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all">所有答案内容</el-dropdown-item>
                            <el-dropdown-item command="answers">不包含快捷栏</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <RoundButton class="paste-btn" :text="pasteToReplaceLable" @btnClick="coverpasteClick('cover')" />
                    <RoundButton class="paste-btn" :text="pasteToEndLable" @btnClick="coverpasteClick('overlay')" />
                    <span class="editor-and-editTime" v-if="this.currentAnswer.answerEditor && this.currentAnswer.answerEditorTime">
                        该答案最后编辑：{{ this.currentAnswer.answerEditor }}
                        &nbsp;
                        {{ this.currentAnswer.answerEditorTime }}
                    </span>
                </div>
            </TitleBar>
            <div class="content-list">
                <WidgetWrapper v-for="widget in currentAnswer.contents" :key="widget.uId" :widget="widget" v-show="widget.updateState != 'delete'" />
            </div>
            <AnswerMore :isEmpty="!currentAnswer.contents.length" />
            <OptionsEdit />
        </div>
        <AnswerProp />
    </div>
</template>

<script>
import TitleBar from "../TitleBar";
import AnswerProp from "./AnswerProp";
import WidgetWrapper from "./WidgetWrapper";
import AnswerMore from "./AnswerMore";
import OptionsEdit from "./OptionsEdit";
import RoundButton from "../../../bComponents/buttons/RoundButton.vue";
import { ANSWER_COPY } from "../../../js/common/constants";
import { localStorage } from "../../../js/common/util";
import { uniqueId } from "../../../js/common/util";

export default {
    name: "AnswerPanel",
    components: {
        TitleBar,
        AnswerProp,
        WidgetWrapper,
        AnswerMore,
        OptionsEdit,
        RoundButton
    },
    data() {
        return {
            titleValue: "",
            isTilteEditing: false
        };
    },
    computed: {
        currentAnswer() {
            return this.getStorePorp("currentAnswer");
        },
        answerName() {
            return this.getStorePorp("currentAnswer").name;
        },
        copyLabel() {
            return this.$t("zhiji.answer.copyBotton");
        },
        pasteToReplaceLable() {
            return this.$t("zhiji.answer.pasteToReplace");
        },
        pasteToEndLable() {
            return this.$t("zhiji.answer.pasteToEnd");
        },
        CopySuccessTips() {
            return this.$t("zhiji.answer.CopySuccess");
        },
        CopyNoShortcuBarTips() {
            return this.$t("zhiji.answer.CopyNoShortcuBar");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        emitEditEvent() {
            const newTitle = this.zhiji.strTrim(this.titleValue);
            const isChanged = newTitle != this.answerName;

            if (newTitle && isChanged) {
                this.titleValue = "";
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "name",
                    newName: newTitle
                });
            }

            this.isTilteEditing = false;
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;

            isEnterKey && this.emitEditEvent();
        },
        editTitle() {
            this.isTilteEditing = true;
            this.$nextTick(() => {
                this.$refs.titleInput && this.$refs.titleInput.focus();
            });
        },
        copyClick(type) {
            // 将当前答案内容保存至本地
            let messageTxt = '';
            if (type === "all") {
                localStorage.set(ANSWER_COPY, {
                    contents: this.currentAnswer.contents,
                    options: this.currentAnswer.options
                });
                messageTxt = this.CopySuccessTips;
            }
            if (type === "answers") {
                localStorage.set(ANSWER_COPY, {
                    contents: this.currentAnswer.contents,
                    options: [],
                });
                messageTxt = this.CopyNoShortcuBarTips;
            }
            this.$message({
                message: messageTxt,
                type: "success",
            });
        },
        coverpasteClick(pasteName) {
            // 获取复制的答案内容
            const answerData = JSON.parse(localStorage.get(ANSWER_COPY));
            if (answerData && (answerData.contents.length > 0 || answerData.options.length > 0)) {
                answerData.contents.forEach(item => {
                    item.uId = uniqueId();
                });
                if (pasteName === "overlay") {
                    // 叠加更新当前答案数据
                    const payload = {
                        type: "updateCurrentAnswer",
                        contents: [...this.currentAnswer.contents, ...answerData.contents],
                        options: [...this.currentAnswer.options, ...answerData.options]
                    }
                    this.$store.commit("zhiji/editQsUpdateAnswer", payload);
                } else {
                    // 覆盖更新当前答案数据
                    const payload = {
                        type: "updateCurrentAnswer",
                        contents: answerData.contents,
                        options: answerData.options
                    }
                    this.$store.commit("zhiji/editQsUpdateAnswer", payload);
                }
            }
        },
        handleCommand(command) {
            this.copyClick(command);
        },
    }
};
</script>

<style lang="less" scoped>
.edit-answer {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-x: auto;
    background: #fff;

    .answer-content {
        padding: 0px 16px 0px 16px;
        flex: 1;
        overflow: auto;
        border-right: solid 1px #d8e4f0;

        .answer-title {
            margin: 0;
        }
    }

    .title-edit-btn {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin: 0 5px 0 5px;
        vertical-align: -3px;
        background: url("@{zhijiStaticImagePath}class-spr.png") -76px 0;

        &:hover {
            background-position: -76px -22px;
        }
    }
    .answer-action {
        margin-left: 5px;
        display: inline-block;

        .paste-btn {
            width: 65px;
            height: 30px;
            min-width: 80px;
            border: solid 1px #d8e4f0;
            border-radius: 30px;
            color: #41475e;
            background: #fff;
            box-shadow: none;
            box-sizing: border-box;
            line-height: 28px;
            margin-right: 8px;
            &:hover {
                color: #2ec2ff;
            }
        }
        .copy-btn {
            margin-right: 8px;
            &:hover {
                color: #2ec2ff;
                cursor: pointer;
            }
            ::v-deep .el-button-group {
                .el-button:first-child {
                    border-radius: 30px 0 0 30px;
                    min-width: 0px;
                }
                .el-button:last-child {
                    border-radius: 0 30px 30px 0;
                    min-width: 0px;
                }
            }
        }

        .paste-btn {
            width: 145px;
        }

        .editor-and-editTime {
            font-weight: normal;
            color: #888;
            font-size: 13px;
        }
    }

    .content-list {
        margin-left: 11px;
        padding: 1px;
        position: relative;
    }
}
</style>
